import { Link } from 'react-router';
import type { TLocalize } from '@hooks/use-localize';
import type { ILabOrdersModel } from '@/types/history/lab-orders';

interface IProps {
    model: ILabOrdersModel;
    t: TLocalize;
}

/** The scrip is ready and a mobile phlebotomist is handling the draw. */
const ReadyPhlebotSection = ({ model, t }: IProps) => (
    <div className="row row-margined">
        <div className="col-xs-12">
            <h1>{t('DashLabel_YouReReadyForLabs', "You're Ready for Labs")}.</h1>

            <p>
                {t('DashLabel_YourLabOrdersHaveBeenProcessedAndWillBeShippedToYouWithTh', 'Your lab orders have been processed and will be shipped to you with the kit that you will need to have ready and available for the appointment you will schedule with a phlebotomist.')}

                <br />
                {t('DashLabel_YouCanAlsoDownloadAndPrintTheOrdersBy', 'You can also download and print the orders by')}{' '}
                <a href="/register/pwl-download-scrip" target="_blank" rel="noopener noreferrer">
                    {t('DashLabel_ClickingHere', 'clicking here')}
                </a>
            </p>

            <h4>{t('DashLabel_NextSteps', 'Next Steps')}</h4>
            <ol>
                <li>
                    {t('DashLabel_ThePhlebotomistWillReachOutToYouWithinTheNextFewDaysToEns', 'The phlebotomist will reach out to you within the next few days to ensure you have the kit before scheduling the appointment')}.
                </li>
                <li>
                    {model.isLiver
                        ? t('DashLabel_AtYourAppointmentYouWillHaveYourBloodDrawn', 'At your appointment, you will have your blood drawn.')
                        : t('DashLabel_AtYourAppointmentYouWillHaveYourBloodDrawnAndSubmitAUrine', 'At your appointment, you will have your blood drawn and submit a urine sample.')}
                </li>
            </ol>

            {model.hasPreferredCenter && (
                <p>
                    {t('DashLabel_NotePreferredCenterContactPostPwl', 'You should be contacted by your coordinator at your previously selected Preferred Center within a few days after your appointment')}
                </p>
            )}

            <div className="journey-opt-out">
                You may withdraw at any time using this link: <Link to={'/register/opt-out/' + model.id + '/' + model.editKey}>Opt-out of the donation process</Link>
            </div>
        </div>
    </div>
);

export default ReadyPhlebotSection;
